import { idSchema } from "@resume-studio/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

import { secretsSchema } from "../secrets";

export const usernameSchema = z
  .string()
  .min(3, { message: "Username must be at least 3 characters." })
  .max(255, { message: "Username must be 255 characters or fewer." })
  .regex(/^[\d._a-z-]+$/, {
    message:
      "Usernames can only contain lowercase letters, numbers, periods, hyphens, and underscores.",
  });

export const userSchema = z.object({
  id: idSchema,
  name: z
    .string()
    .trim()
    .min(1, { message: "Please enter your name." })
    .max(255, { message: "Name must be 255 characters or fewer." }),
  picture: z.literal("").or(z.null()).or(z.string().url()),
  username: usernameSchema,
  email: z.string().trim().email("Please enter a valid email address."),
  locale: z.string().default("en-US"),
  emailVerified: z.boolean().default(false),
  twoFactorEnabled: z.boolean().default(false),
  // `admin` unlocks the `/admin` surface (guard is server-enforced). Default
  // is `user` so every existing token remains scoped to a non-admin.
  role: z.enum(["user", "admin"]).default("user"),
  provider: z.enum(["email", "github", "google"]).default("email"),
  createdAt: z.date().or(z.dateString()),
  updatedAt: z.date().or(z.dateString()),
});

export class UserDto extends createZodDto(userSchema) {}

export const userWithSecretsSchema = userSchema.merge(z.object({ secrets: secretsSchema }));

export class UserWithSecrets extends createZodDto(userWithSecretsSchema) {}
